<template>
  <crm-side-panel
    @handleClose="handleCloseBusiDetail"
    :title="busiOpportunityDetail.name"
  >
    <div class="side-panel-content busi-detail-content">
      <div class="side-panel-buttons">
        <crm-button
          v-if="businessAuth.bizUpdate && businessAuth.bizUpdate.toggleStatus"
          :size="'mini'"
          :text="'编辑'"
          @click="handleUpdate()"
        >
        </crm-button>
        <crm-button
          v-if="businessAuth.bizDelete && businessAuth.bizDelete.toggleStatus"
          :size="'mini'"
          :buttonType="'danger'"
          :text="'删除'"
          @click="handleDelete()"
        >
        </crm-button>
      </div>
      <div class="side-panel-header">
        <!-- 商机信息 -->
        <div class="header-info" style="margin-top: -20px">
          <div class="info-item">
            <p class="info-title">商机编码</p>
            <p class="info-detail">{{ busiOpportunityDetail.businessNo }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">客户名称</p>
            <p class="info-detail">{{ busiOpportunityDetail.customerName }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">预计成交金额(元)</p>
            <p class="info-detail">
              {{ formatMoney(busiOpportunityDetail.dealAmountStr) }}
            </p>
          </div>
          <div class="info-item">
            <p class="info-title">阶段</p>
            <p class="info-detail">
              {{ busiOpportunityDetail.businessTypeName }}
            </p>
          </div>
          <div class="info-item">
            <p class="info-title">业务员</p>
            <p class="info-detail">{{ busiOpportunityDetail.userName }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">业务员所属部门</p>
            <p class="info-detail" :title="busiOpportunityDetail.teamName">
              {{ busiOpportunityDetail.teamName }}
            </p>
          </div>
        </div>
        <!-- 商机阶段变更 -->
        <div class="busi-opportunity-stage clearfix">
          <el-col id="crumbs" :span="20">
            <ul class="clearfix">
              <li
                v-for="(item, index) of busiStepList"
                :key="index"
                :status="item.stepClickStatus"
                v-if="index !== 6"
                @click="handleStepChange(index)"
              >
                <a
                  href="#"
                  :class="{
                    HoverBackground: display == index,
                    activeBackground: stageIndex == index,
                  }"
                >
                  {{ item.title }}
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="toolTipList[index]"
                    placement="bottom"
                  >
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </a>
              </li>
              <li v-else>
                <el-dropdown
                  trigger="click"
                  @command="handleListenDropDown"
                  v-if="isStageEndSelect"
                >
                  <a
                    class="el-dropdown-link"
                    href="#"
                    :class="{
                      HoverBackground: display == index,
                      activeBackground: stageIndex == index,
                    }"
                  >
                    {{ endType }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                    <el-tooltip class="item" effect="dark" placement="bottom">
                      <span slot="content"
                        >验收回款：按合同交付，客户确认我方提供解决方案的价值；商机失败：客户合作失败；</span
                      >
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </a>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="busiStageList[6].name">
                      <i class="el-icon-success" style="color: #67c23a"></i>
                      {{ busiStageList[6].name }}
                    </el-dropdown-item>
                    <el-dropdown-item :command="busiStageList[7].name">
                      <i class="el-icon-error" style="color: #f56c6c"></i>
                      {{ busiStageList[7].name }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <a
                  v-else
                  :class="{
                    HoverBackground: display == index,
                    activeBackground: stageIndex == index,
                  }"
                >
                  {{ endType }}
                  <el-tooltip class="item" effect="dark" placement="bottom">
                    <span slot="content">
                      验收回款：按合同交付，客户确认我方提供解决方案的价值；商机失败：客户合作失败；
                    </span>
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </a>
              </li>
            </ul>
          </el-col>
          <el-col
            v-if="
              !this.isStageFinish &&
              businessAuth.bizStagechange &&
              businessAuth.bizStagechange.toggleStatus
            "
            :span="4"
            style="margin-left: -20px; margin-top: 10px"
          >
            <crm-button
              v-if="isNext"
              :text="'进入下一阶段'"
              @click="handleConfirmFormShow('nextStage')"
            >
            </crm-button>
            <crm-button
              v-else
              :text="'变更为当前阶段'"
              @click="handleConfirmFormShow('stageChange')"
            >
            </crm-button>
          </el-col>
        </div>
      </div>
      <!-- 商机各tab -->
      <div class="side-panel-tabs">
        <el-tabs
          v-model="activeTab"
          @tab-click="handleClick"
          :stretch="false"
          v-loading="loading"
        >
          <!-- 商机信息tab -->
          <el-tab-pane label="基本信息" name="info">
            <pane-info :detail="busiOpportunityDetail"></pane-info>
          </el-tab-pane>
          <el-tab-pane
            v-if="
              businessAuth.bizQueryProductLine &&
              businessAuth.bizQueryProductLine.toggleStatus
            "
            label="产品线"
            name="productLine"
          >
            <div>
              <crm-button
                :size="'mini'"
                :text="'新增'"
                class="fr mb10"
                @click="handlerProductLineAdd"
                v-if="
                  businessAuth.bizProductLineAdd &&
                  businessAuth.bizProductLineAdd.toggleStatus
                "
              >
              </crm-button>
            </div>
            <el-table :data="productLineData.results" height="100%" style="width: 100%">
              <el-table-column prop="name" label="产品线名称" width="160" align="center">
              </el-table-column>
              <el-table-column
                prop="dealAmount"
                label="预计成交金额"
                width="160"
                align="center"
              >
                <template slot-scope="scope">
                  {{ formatMoney(scope.row.dealAmount) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="remark"
                label="产品线说明"
                width="200"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="stageTip"
                label="产品线阶段提示"
                width="200"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="fileList"
                show-overflow-tooltip
                label="产品线附件"
                align="center"
              >
                <template slot-scope="scope">
                  <p v-for="item in scope.row.fileList" :key="item.id">
                    <a href="javascript:;" @click="getFildUrl(item)">
                      {{ item.fileName }}
                    </a>
                  </p>
                </template>
              </el-table-column>
              <el-table-column
                prop="gmtCreatedStr"
                label="添加时间"
                width="160"
                align="center"
              >
              </el-table-column>
              <el-table-column width="100" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-if="
                      businessAuth.bizProductLineUpdate &&
                      businessAuth.bizProductLineUpdate.toggleStatus
                    "
                    @click="handleProductLineUpdate(scope)"
                    type="text"
                    size="small"
                  >
                    编辑
                  </el-button>
                  <el-button
                    v-if="
                      businessAuth.bizProductLineDel &&
                      businessAuth.bizProductLineDel.toggleStatus
                    "
                    @click="handleDeleteProductLine(scope)"
                    type="text"
                    size="small"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleProductLineSizeChange"
                @current-change="handleProductLineCurrentChange"
                :current-page="productLineData.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="productLineData.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="productLineData.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 联系人tab -->
          <el-tab-pane
            v-if="businessAuth.bizConvertTab && businessAuth.bizConvertTab.toggleStatus"
            label="联系人"
            name="salesman"
          >
            <el-table :data="detailContacts.results" height="100%" style="width: 100%">
              <el-table-column prop="name" label="联系人姓名" width="160" align="center">
              </el-table-column>
              <el-table-column prop="mobile" label="联系方式" align="center">
              </el-table-column>
              <el-table-column prop="typeName" label="联系人类型" align="center">
              </el-table-column>
              <el-table-column prop="duty" label="联系人职务" align="center">
              </el-table-column>
              <el-table-column prop="contactDepa" label="联系人部门" align="center">
              </el-table-column>
              <el-table-column prop="contactEmail" label="联系人邮箱" align="center">
              </el-table-column>
              <el-table-column prop="landline" label="座机" align="center">
              </el-table-column>
              <el-table-column prop="contactQQ" label="微信/QQ" align="center">
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleSalesmanSizeChange"
                @current-change="handleSalesmanCurrentChange"
                :current-page="salesmanData.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="salesmanData.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="detailContacts.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 拜访记录tab -->
          <el-tab-pane
            v-if="businessAuth.bizVisitTab && businessAuth.bizVisitTab.toggleStatus"
            label="拜访记录"
            name="visit"
          >
            <div>
              <crm-button
                :size="'mini'"
                :text="'拜访'"
                class="fr mb10"
                @click="toVisit"
                v-if="visitAuth.visitAdd && visitAuth.visitAdd.toggleStatus"
              >
              </crm-button>
            </div>
            <el-table :data="busiVisitData.results" height="100%" style="width: 100%">
              <el-table-column
                prop="visitDateStr"
                label="拜访时间"
                width="160"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="visitTypeName"
                label="拜访方式"
                width="80"
                align="center"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                width="200"
                prop="visitAim"
                label="拜访事宜"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="isFinished"
                label="是否完成"
                width="80"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.isFinished === 0 ? "未完成" : "已完成" }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="visitNote"
                label="拜访结果"
                width="200"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="salesmanName"
                label="业务员"
                width="80"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="teamName" label="团队" align="center">
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleVisitSizeChange"
                @current-change="handleVisitCurrentChange"
                :current-page="visitData.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="visitData.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="busiVisitData.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 销售记录tab -->
          <el-tab-pane
            v-if="businessAuth.bizRecordTab && businessAuth.bizRecordTab.toggleStatus"
            label="销售记录"
            name="sale"
          >
            <el-table :data="busiSalesData.results" height="100%" style="width: 100%">
              <el-table-column
                prop="creatorName"
                label="操作人"
                width="100"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="stage" label="商机阶段" width="150" align="center">
              </el-table-column>
              <el-table-column
                prop="gmtCreatedStr"
                label="记录时间"
                width="180"
                align="center"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="content"
                label="销售记录"
                align="center"
              >
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleSalesSizeChange"
                @current-change="handleSalesCurrentChange"
                :current-page="salesData.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="salesData.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="busiSalesData.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 合同 -->
          <el-tab-pane
            v-if="
              businessAuth.bizContractQuery && businessAuth.bizContractQuery.toggleStatus
            "
            label="合同"
            name="contract"
          >
            <div>
              <!-- 合同失败且没权限不能新增合同 -->
              <template v-if="isShangJi">
                <el-dropdown
                  trigger="click"
                  @command="handleAddContract"
                  class="fr mb10"
                  v-if="
                  busiOpportunityDetail.businessType !==
                    '66cd47cd7641479fa9e23f21b085cfdb' &&
                  businessAuth.bizContractAddBtn &&
                  businessAuth.bizContractAddBtn.toggleStatus
                "
                >
                  <crm-button :size="'mini'" :text="'新增'">
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </crm-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="addNew">新增合同</el-dropdown-item>
                    <el-dropdown-item command="addHad">已有合同</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
              <template v-else>
                <crm-button
                  :size="'mini'"
                  :text="'新增合同'"
                  class="fr mb10"
                  @click="toAddContract"
                  v-if="
                  busiOpportunityDetail.businessType !==
                    '66cd47cd7641479fa9e23f21b085cfdb' &&
                  businessAuth.bizContractAddBtn &&
                  businessAuth.bizContractAddBtn.toggleStatus
                "
                >
                </crm-button>
              </template>
            </div>
            <el-table :data="bizContractData.results" height="100%" style="width: 100%">
              <el-table-column
                prop="contractNo"
                label="合同编号"
                width="160"
                align="center"
              >
                <template slot-scope="scope">
                  <span class="link" @click="handleCompactDetailShow(scope)">{{
                    scope.row.contractNo
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="contractAmount"
                label="合同金额（元）"
                width="160"
                align="center"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                width="160"
                prop="refundAmount"
                label="回款金额（元）"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="receivableAmount"
                label="应收金额（元）"
                width="160"
                align="center"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="settlementName"
                label="结算方式"
                width="200"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="startDateStr"
                label="开始日期"
                width="100"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="endDateStr"
                label="结束日期"
                align="center"
                width="100"
              >
              </el-table-column>
              <el-table-column prop="salesmanName" label="业务员" align="center">
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleContractSizeChange"
                @current-change="handleContractCurrentChange"
                :current-page="bizContractData.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="bizContractData.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="bizContractData.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 项目 -->
          <el-tab-pane
            v-if="
              businessAuth.bizProjectQueryList &&
              businessAuth.bizProjectQueryList.toggleStatus
            "
            label="项目"
            name="project"
          >
            <div class="project-tipText">
              <span>
                说明：新增立项系统对接延迟10分钟同步项目数据，立项审批过程，请从集团OA中查看！
              </span>
              <el-dropdown
                trigger="click"
                @command="handleAddProject"
                v-if="
                  businessAuth.bizProjectAddBtn &&
                  businessAuth.bizProjectAddBtn.toggleStatus
                "
              >
                <crm-button :size="'mini'" :text="'新增'">
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </crm-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="addNew">新项目</el-dropdown-item>
                  <el-dropdown-item command="addHad">已有项目</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <el-table
              :data="projectData.results"
              class="tab-table-item"
              height="100%"
              style="width: 100%"
            >
              <el-table-column prop="name" label="项目名称" width="180" align="center" />
              <el-table-column prop="code" label="项目编码" width="150" align="center" />
              <el-table-column
                prop="status"
                label="项目状态"
                width="100"
                align="center"
              />
              <el-table-column prop="productLine" label="产品线" align="center" />
              <el-table-column prop="projectArea" label="所属区域" align="center" />
              <el-table-column
                prop="minimumBudgetUnit"
                label="最小预算单元"
                width="300"
                align="center"
              />
              <el-table-column prop="personCharge" label="负责人" align="center" />
              <el-table-column
                prop="gmtCreatedStr"
                label="创建时间"
                width="180"
                align="center"
              />
              <el-table-column width="100" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-if="
                      businessAuth.bizProjectDelete &&
                      businessAuth.bizProjectDelete.toggleStatus
                    "
                    @click="handleDeleteProject(scope)"
                    type="text"
                    size="small"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleProjectSizeChange"
                @current-change="handleProjectCurrentChange"
                :current-page="projectData.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="projectData.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="projectData.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 附件tab -->
          <el-tab-pane
            v-if="businessAuth.bizFileTab && businessAuth.bizFileTab.toggleStatus"
            label="附件"
            name="file"
          >
            <el-upload
              class="mb10 text-right"
              action="string"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :http-request="handleUploadFile"
            >
              <crm-button
                v-if="
                  businessAuth.bizFileUpload && businessAuth.bizFileUpload.toggleStatus
                "
                :buttonType="'secondary'"
                :size="'mini'"
                :text="'上传附件'"
              >
                <el-tooltip
                  content="图片文件单个不能超过5M；其他文件单个不能超过50M"
                  class="item"
                  effect="dark"
                  placement="top"
                >
                  <span class="el-icon-question" style="font-size: 16px"></span>
                </el-tooltip>
              </crm-button>
            </el-upload>
            <el-table
              :data="busiFileData.results"
              class="tab-table-item"
              height="100%"
              style="width: 100%"
            >
              <el-table-column
                prop="creatorName"
                label="操作人"
                width="100"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="gmtCreatedStr"
                label="上传时间"
                width="150"
                align="center"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="fileUrl"
                label="附件"
                align="center"
              >
                <template slot-scope="scope">
                  <a
                    v-if="
                      businessAuth.busFilePreview &&
                      businessAuth.busFilePreview.toggleStatus &&
                      scope.row.previewUrl
                    "
                    href="javascript:;"
                    @click="getFildUrl(scope.row)"
                  >
                    {{ scope.row.fileName }}
                  </a>
                  <span v-else>{{ scope.row.fileName || "暂无数据" }}</span>
                </template>
              </el-table-column>
              <el-table-column width="100" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-if="
                      businessAuth.bizFileDelete &&
                      businessAuth.bizFileDelete.toggleStatus
                    "
                    @click="handleDeleteFile(scope)"
                    type="text"
                    size="small"
                  >
                    删除
                  </el-button>
                  <a
                    v-if="
                      businessAuth.bizFileDownload &&
                      businessAuth.bizFileDownload.toggleStatus &&
                      scope.row.fileUrl
                    "
                    :href="scope.row.fileUrl"
                  >
                    下载
                  </a>
                </template>
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleFileSizeChange"
                @current-change="handleFileCurrentChange"
                :current-page="fileData.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="fileData.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="busiFileData.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- 商机阶段冻结、恢复、变更确认弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="confirmFormVisible"
      :append-to-body="true"
      width="40%"
      @close="initConfirmForm"
    >
      <div class="dialog-main add-dialog">
        <p class="dialog-title">{{ confirmForm.title }}</p>
        <ul class="tip">
          <li
            v-for="(item, key) in confirmForm.stageTipList.slice(0, confirmForm.end)"
            :key="key"
          >
            <p class="title-tip">{{ item.name }}阶段提示</p>
            <p>{{ item.stageTip || "暂无提示" }}</p>
          </li>
          <div
            v-if="confirmForm.stageTipList.length > 3"
            class="toggleBtn"
            @click="handlerToggleChecked()"
          >
            <label class="btn-toggle">{{
              !confirmForm.toggleChecked ? "展开全部" : "隐藏"
            }}</label>
          </div>
        </ul>
        <el-form
          label-position="right"
          ref="confirmForm"
          :model="confirmForm"
          :rules="confirmFormRules"
        >
          <el-form-item class="busi-dialog" :label="confirmForm.label" prop="description">
            <el-input
              type="textarea"
              style="width: 100%"
              :placeholder="confirmForm.placeholder"
              :rows="5"
              v-model="confirmForm.description"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <crm-button :buttonType="'plain'" :text="'取消'" @click="handleCancelConfirmForm">
        </crm-button>
        <crm-button :text="'确定'" @click="handleSaveConfirmForm"></crm-button>
      </div>
    </el-dialog>

    <edit-busi
      v-if="isEditBusiVisible"
      :moduleName="'opportunity'"
      :visible="isEditBusiVisible"
      :detail="editDetail"
      @close="isEditBusiVisible = false"
      @success="saveAddUpdate"
    >
    </edit-busi>
    <el-image-viewer
      v-if="imagePreview.showImage"
      :on-close="closeViewer"
      :url-list="[...imagePreview.url]"
    />
    <!-- 新增拜访 -->
    <add-visit
      v-if="isAddVisitVisible"
      :visible="isAddVisitVisible"
      :detail="visitDetail"
      @success="handleGetVisitData(1)"
      @close="isAddVisitVisible = false"
    >
    </add-visit>
    <!-- 新增编辑产品线 -->
    <edit-product-Line
      v-if="isProductLineDialogVisible"
      :visible="isProductLineDialogVisible"
      :detail="productLinetDetail"
      :hasList="productLineData.results"
      @refresh="refreshProductLine"
      @close="isProductLineDialogVisible = false"
    >
    </edit-product-Line>

    <!-- 新增合同弹窗 -->
    <add-compact
      v-if="addCompactDialogVisible"
      :detail="compactDetail"
      :customId="compactDetail.customId"
      @close="addCompactDialogVisible = false"
      @success="handleGetContractData({ pageNumber: 1 })"
    >
    </add-compact>
    <!-- 合同详情侧面板 -->
    <transition name="slide-fade">
      <template v-if="envCrm">
        <div v-show="compactDetailVisibleInside">
          <compact-detail-inside
            :row="row"
            :detailId="contractId"
            :detailTabName="detailTabName"
            @handleCloseDetail="handleCloseCompactDetail"
          >
          </compact-detail-inside>
        </div>
      </template>
      <template v-else>
        <div v-show="compactDetailVisible">
          <compact-detail
            :row="row"
            :detailId="compactDetailId"
            :detailTabName="detailTabName"
            @handleCloseDetail="handleCloseCompactDetail"
          >
          </compact-detail>
        </div>
      </template>
    </transition>

    <!-- 选择已有项目 -->
    <el-dialog
      title="选择已有项目"
      :visible.sync="isDialogProjectVisible"
      width="40%"
      append-to-body
      @close="cancelProjectDialogVisible"
    >
      <el-form :model="addProjectForm" ref="addProjectForm" label-width="100px">
        <el-form-item
          label="项目:"
          prop="projectId"
          :rules="{
            required: true,
            message: '请选择项目',
            trigger: 'change',
          }"
        >
          <el-select
            size="medium"
            class="addProject"
            clearable
            filterable
            remote
            placeholder="请选择项目"
            :remote-method="queryVisibleProject"
            :loading="addProjectForm.loading"
            v-model="addProjectForm.projectId"
            @change="chooseProject"
          >
            <el-option
              v-for="item in visibleProjectList"
              :label="`${item.projectName}`"
              :value="item.projectId"
              :key="item.projectId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <p class="addProject-tip">说明：无法查到项目时，请联系项目负责人</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelProjectDialogVisible">取 消</el-button>
        <el-button type="primary" @click="handleAddProjectChange">确 定</el-button>
      </span>
    </el-dialog>

    <!-- OA ONLINE -->
    <el-dialog
      :visible.sync="connectOAVisible"
      :fullscreen="true"
      width="80%"
      height="800"
      append-to-body
      @close="cancelAddProjectDialogVisible"
    >
      <iframe :src="OAUrl" frameborder="0" width="100%" height="700"></iframe>
    </el-dialog>

    <!--选择已有合同-->
    <choose-contract ref="chooseContract" :businessId="businessId"
                     @success="chooseSuccess"
                     :detailId="detailId"/>
  </crm-side-panel>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import { formatTimeShow, formatMoney, formatTime } from "@/scripts/utils";
import { uploadFileVerify } from "@/scripts/reg";

import EditBusi from "~component/business/busiopportunity/editBusi.vue";
import EditProductLine from "~component/business/busiopportunity/editProductLine.vue";
import AddCompact from "~component/business/compact/AddCompact.vue";
import CrmSidePanel from "~component/base/crmSidePanel.vue";
import CrmButton from "@/components/base/crmButton";
import PaneInfo from "./pane-info.vue";
import AddVisit from "@/components/business/visit/addVisit";
import CompactDetail from "~component/business/compact/detail.vue";
import service from "@/services/api/business";
import projectService from "@/services/api/project";
import { Loading } from "element-ui";
import cookie from 'js-cookie';
import CompactDetailInside from "@/pages/compact-inside/component";
import ChooseContract from './chooseContract.vue';

import _ from "lodash";

export default {
  components: {
    EditBusi,
    CrmSidePanel,
    CrmButton,
    PaneInfo,
    AddVisit,
    EditProductLine,
    AddCompact,
    CompactDetail,
    CompactDetailInside,
    ChooseContract,
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  filters: {
    formatTimeShow,
  },
  props: {
    nextButtonState: {
      type: Boolean,
    },
    detailId: {
      type: String,
    },
    businessId: {
      type: String,
    },
    isShangJi: {
      type: Boolean,
    },
  },
  data() {
    const ruleMessage = (rule, value, callback) => {
      if (value === "") {
        if (this.eventType === "stageChange" || this.eventType === "nextStage") {
          callback(new Error("请填写阶段销售记录!"));
        }
      } else if (
        (value.length < 30 || value.length > 200) &&
        (this.eventType === "stageChange" || this.eventType === "nextStage")
      ) {
        callback(new Error("请填写30-200字的阶段销售记录!"));
      } else {
        callback();
      }
    };
    return {
      visitDetail: {},
      isAddVisitVisible: false,
      imagePreview: {
        showImage: false,
        url: "",
      },
      isEditBusiVisible: false,
      editDetail: {},
      isAdd: false,
      isRefresh: false,
      isStageFinish: false,
      loading: false,
      endType: "结束",
      isStageEndSelect: true,
      // 商机阶段
      stageIndex: 7,
      changeStageIndex: null,
      busiStepList: [],
      finishType: null,
      isNext: true,
      activeTab: "info",
      display: 7,
      // 冻结、恢复、变更阶段弹窗
      confirmFormVisible: false,
      eventType: "",
      confirmForm: {
        title: "",
        label: "",
        description: "",
        placeholder: "",
        stageTipList: [],
        toggleChecked: false,
        end: 3,
      },
      confirmFormRules: {
        description: [{ required: true, validator: ruleMessage, trigger: "change" }],
      },
      salesmanData: {
        pageNumber: 1,
        pageSize: 5,
      },
      visitData: {
        pageNumber: 1,
        pageSize: 5,
      },
      salesData: {
        pageNumber: 1,
        pageSize: 5,
      },
      fileData: {
        pageNumber: 1,
        pageSize: 5,
      },
      productLineData: {
        pageNumber: 1,
        pageSize: 5,
        results: [],
        totalCount: null,
      },
      bizContractData: {
        pageNumber: 1,
        pageSize: 5,
        results: [],
        totalCount: null,
      },
      projectData: {
        pageNumber: 1,
        pageSize: 5,
        results: [],
        totalCount: null,
      },
      // 提示信息
      toolTipList: [
        "触达客户，使客户认可与我方的合作价值",
        "客户明确表示有兴趣与我方达成合作",
        "提出解决方案，触达决策人物",
        "客户关键决策人同意在初步解决方案基础上继续推进",
        "签订框架协议",
        "签订双赢合同",
      ],
      // 产品线新增编辑弹框
      isProductLineDialogVisible: false,
      productLinetDetail: {},
      // 合同
      addCompactDialogVisible: false,
      // 合同详情
      detailTabName: null,
      compactDetail: {},
      row: {},
      compactDetailId: "",
      compactDetailVisible: false,
      isDialogProjectVisible: false,
      // 已有项目
      visibleProjectList: [],
      // 新增项目-选择已有项目
      addProjectForm: {
        projectId: "",
        loading: false,
        projectItem: {},
      },
      // 走OA新增
      connectOAVisible: false,
      OAUrl: "",
      envCrm: cookie.get("_env_crm__") !== "false",
      compactDetailVisibleInside: false,
      contractId: '',
    };
  },
  watch: {
    nextButtonState: {
      handler(val) {
        this.isNext = true;
        this.isStageFinish = false;
        this.isRefresh = false;
        this.busiStepList.forEach((item) => {
          item.stepClickStatus = "";
        });
        if (this.busiStageList.length === 0) {
          this.getBusiStageList({
            pageNumber: 1,
            pageSize: 20,
            code: "category_business_type",
          }).then(() => {
            this.initBusiStageList();
          });
        } else {
          this.initBusiStageList();
        }
        if (val) {
          this.activeTab = "info";
          this.endType = "结束";
          this.isStageEndSelect = true;
          this.handleQueryDetail().then(() => {
            this.stageIndex = this.busiStageList.indexOf(
              this.busiStageList.find(
                (item) => item.name === this.busiOpportunityDetail.businessTypeName
              )
            );
            this.changeStageIndex = this.stageIndex + 1;
            this.display = this.stageIndex;
            this.stageIndex = this.stageIndex;

            if (this.stageIndex === 6 || this.stageIndex === 7) {
              this.endType = this.busiStageList[this.stageIndex].name;
              this.isStageEndSelect = false;
              this.stageIndex = 6;
              this.isStageFinish = true;
            }
          });
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      crmAuth: "common/crmAuth",
      businessAuth: "authority/businessAuth",
      userInfo: "authority/userInfo",
      busiStageList: "business/busiStageList",
      busiOpportunityDetail: "business/busiOpportunityDetail",
      busiVisitData: "business/busiVisitData",
      busiSalesData: "business/busiSalesData",
      busiFileData: "business/busiFileData",
      detailContacts: "business/detailContacts",
      visitAuth: "authority/visitAuth",
      contractAuth: "authority/contractAuth",
    }),
  },
  methods: {
    formatMoney,
    ...mapActions({
      getBusiStageList: "business/getBusiStageList",
      saveBusiAbolish: "business/saveBusiAbolish",
      saveBusiRecover: "business/saveBusiRecover",
      deleteBusiOpportunity: "business/deleteBusiOpportunity",
      getBusiOpprtunityDetail: "business/getBusiOpprtunityDetail",
      getDetailContactsList: "business/getDetailContactsList",
      getBusiVisitData: "business/getBusiVisitData",
      getBusiSalesData: "business/getBusiSalesData",
      getBusiFileData: "business/getBusiFileData",
      deleteBusiFile: "business/deleteBusiFile",
      saveBusiStageChange: "business/saveBusiStageChange",
      uploadFile: "business/uploadFile",
      getAuthority: "authority/getAuthority",
    }),
    initBusiStageList() {
      this.busiStepList = [];
      this.busiStageList.forEach((item) => {
        if (item.name !== "验收回款" && item.name !== "商机失败") {
          this.busiStepList.push({
            title: item.name,
            uid: item.uid,
            stepClickStatus: "",
          });
        } else if (item.name === "验收回款") {
          this.busiStepList.push({
            title: "结束",
            uid: "",
            stepClickStatus: "",
          });
        }
      });
    },
    htmlDecodeByRegExp(str) {
      var s = "";
      if (str.length === 0) return "";
      s = str.replace(/&amp;/g, "&");
      s = s.replace(/&lt;/g, "<");
      s = s.replace(/&gt;/g, ">");
      s = s.replace(/&nbsp;/g, " ");
      s = s.replace(/&#39;/g, "'");
      s = s.replace(/&quot;/g, '"');
      return s;
    },
    closeViewer() {
      this.imagePreview.showImage = false;
      this.move();
    },
    // 停止页面滚动
    stopMove() {
      const m = (e) => {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", m, { passive: false }); // 禁止页面滑动
    },
    // 开启页面滚动
    move() {
      const m = (e) => {
        e.preventDefault();
      };
      document.body.style.overflow = "auto"; // 出现滚动条
      document.removeEventListener("touchmove", m, { passive: true });
    },
    getFildUrl(row) {
      this.imagePreview.url = "";
      const typeArr = row.fileName.split(".");
      if (["png", "jpg", "jpeg"].includes(typeArr[typeArr.length - 1])) {
        this.imagePreview.url = row.previewUrl;
        this.imagePreview.showImage = true;
        this.stopMove();
        return;
      }
      if (typeArr[typeArr.length - 1] === "pdf") {
        window.open(row.previewUrl);
        return;
      }
      const url = this.htmlDecodeByRegExp(row.fileUrl);
      window.open(`https://view.officeapps.live.com/op/view.aspx?src=${url}`);
    },
    handleCloseBusiDetail() {
      this.$emit("handleCloseBusiDetail", this.isRefresh);
      this.isNext = true;
    },
    handleStopHideDialog(events) {
      events.stopPropagation();
    },
    // 编辑
    handleUpdate() {
      this.isAdd = false;
      Promise.all([
        this.getDetailContactsList({
          businessId: this.detailId,
          pageSize: 20,
          pageNumber: 1,
        }),
        this.getBusiOpprtunityDetail({ id: this.businessId || this.detailId }),
      ]).then(() => {
        const nextForm = this.$_.pick(this.busiOpportunityDetail, [
          "id",
          "customerName",
          "customerId",
          "businessLine",
          "name",
          "intention",
          "dealAmountStr",
          "dealDateStr",
          "remarks",
          "userId",
          "productLineList",
          "businessNo",
        ]);
        nextForm.converts = [];
        this.detailContacts.results.forEach((item) => {
          nextForm.converts.push(item.uid);
        });
        this.editDetail = nextForm;
        this.isEditBusiVisible = true;
      });
    },
    saveAddUpdate() {
      this.handleQueryDetail();
      this.isRefresh = true;
    },
    // 删除商机
    handleDelete() {
      this.$confirm("是否确定删除商机？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteBusiOpportunity({
            id: this.detailId,
          }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.isRefresh = true;
            this.handleCloseBusiDetail();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 结束方式切换
    handleListenDropDown(value) {
      if (!this.isStageFinish) {
        this.endType = value;
        this.handleStepChange(6);
      }
    },
    // 阶段点击
    handleStepChange(index) {
      if (this.businessAuth.bizStagechange.toggleStatus && !this.isStageFinish) {
        this.display = index;
        this.changeStageIndex = index;

        this.busiStepList.forEach((item) => {
          item.stepClickStatus = "";
        });
        if (index !== this.stageIndex) {
          this.busiStepList[index].stepClickStatus = "process";
          this.isNext = index === this.stageIndex + 1;
        }
      }
    },
    // 冻结、变更阶段、恢复弹窗
    async handleConfirmFormShow(eventType) {
      if (
        (eventType === "stageChange" &&
          this.endType === "结束" &&
          this.changeStageIndex === 6) ||
        (eventType === "nextStage" &&
          this.endType === "结束" &&
          this.stageIndex + 1 === 6)
      ) {
        this.$message({
          type: "error",
          message: "请选择结束方式！",
        });
        return;
      }
      this.eventType = eventType;
      if (eventType === "stageChange" || eventType === "nextStage") {
        this.handleSetConfirmFormInfo(
          "是否确认变更商机阶段？",
          "阶段销售记录：",
          "建议填写内容：关键人、关键会谈信息、阶段变更的原因（不少于30字）"
        );
      }
      await service.queryStageTip({ businessId: this.detailId }).then((res) => {
        this.confirmForm.stageTipList =
          res.data.data[this.changeStageIndex]?.stageList || res.data.data[0]?.stageList;
      });
      this.confirmFormVisible = true;
    },
    handleSetConfirmFormInfo(title, label, placeholder) {
      this.confirmForm.title = title;
      this.confirmForm.label = label;
      this.confirmForm.placeholder = placeholder;
    },
    initConfirmForm() {
      this.confirmForm.stageTipList = [];
      this.confirmForm.toggleChecked = false;
      this.confirmForm.end = 3;
      this.$refs.confirmForm.resetFields();
    },
    handleCancelConfirmForm() {
      this.confirmFormVisible = false;
      this.initConfirmForm();
      this.confirmForm.stageTipList = [];
      this.confirmForm.toggleChecked = false;
      this.confirmForm.end = 3;
    },
    handleConfirmSuccess(sucMessage) {
      this.$message({
        type: "success",
        message: sucMessage,
      });
      this.confirmFormVisible = false;
      this.confirmForm.stageTipList = [];
      this.confirmForm.toggleChecked = false;
      this.confirmForm.end = 3;
      this.$refs.confirmForm.resetFields();
    },
    handleSaveConfirmForm() {
      this.$refs.confirmForm.validate((valid) => {
        if (valid) {
          if (this.eventType === "stageChange" || this.eventType === "nextStage")
            this.handleSaveStageForm();
        }
      });
    },
    handleSaveStageForm() {
      this.saveBusiStageChange({
        id: this.detailId,
        remarks: this.confirmForm.description,
        businessType: this.handleSetBusinessType(),
      }).then(() => {
        this.handleConfirmSuccess("商机阶段变更成功！");
        this.handleGetSalesData();
        this.handleQueryDetail().then(() => {
          this.busiStepList.forEach((item) => {
            item.stepClickStatus = "";
          });
          const curStageItem = this.busiStageList.find(
            (item) => item.name === this.busiOpportunityDetail.businessTypeName
          );
          this.stageIndex = this.busiStageList.indexOf(curStageItem);
          this.display = this.stageIndex;
          this.changeStageIndex = this.stageIndex + 1;

          if (this.stageIndex === 6 || this.stageIndex === 7) {
            this.endType = this.busiStageList[this.stageIndex].name;
            this.stageIndex = 6;
            this.isStageFinish = true;
          } else {
            this.isNext = true;
          }
        });
        this.isRefresh = true;
      });
    },
    handleQueryDetail() {
      this.loading = true;
      return this.getBusiOpprtunityDetail({ id: this.businessId || this.detailId }).finally(() => {
        this.loading = false;
      });
    },
    handleSetBusinessType() {
      let businessType = "";
      if (this.changeStageIndex === 6 || this.stageIndex + 1 === 7) {
        const endStageUid = this.busiStageList.find((item) => item.name === this.endType)
          .uid;
        businessType = endStageUid;
      } else {
        const notEndStageUid = this.busiStageList.find(
          (item) => item.name === this.busiStepList[this.changeStageIndex].title
        ).uid;
        businessType = notEndStageUid;
      }
      return businessType;
    },
    // tab 切换
    handleClick(tab) {
      let p = null;
      this.loading = true;
      switch (tab.name) {
        case "info":
          p = this.getBusiOpprtunityDetail({ id: this.businessId || this.detailId });
          break;
        case "salesman":
          this.salesmanData.pageNumber = 1;
          this.salesmanData.pageSize = 5;
          p = this.handleGetSalesmanData();
          break;
        case "visit":
          this.visitData.pageNumber = 1;
          this.visitData.pageSize = 5;
          p = this.handleGetVisitData();
          break;
        case "sale":
          this.salesData.pageNumber = 1;
          this.salesData.pageSize = 5;
          p = this.handleGetSalesData();
          break;
        case "file":
          this.fileData.pageNumber = 1;
          this.fileData.pageSize = 5;
          p = this.handleGetFileData();
          break;
        case "productLine":
          this.productLineData.pageNumber = 1;
          this.productLineData.pageSize = 5;
          p = this.handleGetProductLineData();
          break;
        case "contract":
          this.bizContractData.pageNumber = 1;
          this.bizContractData.pageSize = 5;
          p = this.handleGetContractData();
          break;
        case "project":
          this.projectData.pageNumber = 1;
          this.projectData.pageSize = 5;
          p = this.handleGetProjectData();
          break;
        default:
          p = Promise.reject();
          break;
      }
      p.finally(() => {
        this.loading = false;
      });
    },
    handleGetSalesmanData() {
      return this.getDetailContactsList({
        businessId: this.detailId,
        pageSize: this.salesmanData.pageSize,
        pageNumber: this.salesmanData.pageNumber,
      });
    },
    handleSalesmanCurrentChange(val) {
      this.salesmanData.pageNumber = val;
      this.handleGetSalesmanData();
    },
    handleSalesmanSizeChange(val) {
      this.salesmanData.pageSize = val;
      this.salesmanData.pageNumber = 1;
      this.handleGetSalesmanData();
    },
    // 拜访记录
    handleGetVisitData(pageNumber) {
      return this.getBusiVisitData({
        businessUid: this.detailId,
        pageSize: this.visitData.pageSize,
        pageNumber: pageNumber || this.visitData.pageNumber,
      });
    },
    handleVisitCurrentChange(val) {
      this.visitData.pageNumber = val;
      this.handleGetVisitData();
    },
    handleVisitSizeChange(val) {
      this.visitData.pageSize = val;
      this.visitData.pageNumber = 1;
      this.handleGetVisitData();
    },
    // 销售记录
    handleGetSalesData() {
      return this.getBusiSalesData({
        businessUid: this.detailId,
        pageSize: this.salesData.pageSize,
        pageNumber: this.salesData.pageNumber,
      });
    },
    handleSalesCurrentChange(val) {
      this.salesData.pageNumber = val;
      this.handleGetSalesData();
    },
    handleSalesSizeChange(val) {
      this.salesData.pageSize = val;
      this.salesData.pageNumber = 1;
      this.handleGetSalesData();
    },
    // 附件表格
    async beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 50;

      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 50MB!");
        return Promise.reject();
      }
      /* eslint-disable */
      try {
        return await uploadFileVerify(file.name);
      } catch (e) {
        this.$message(e);
        return Promise.reject();
      }
    },
    handleUploadFile(item) {
      this.notify = this.$notify({
        iconClass: "el-icon-loading",
        title: "",
        message: "正在上传中，请稍后...",
        duration: 0,
        showClose: false,
      });
      const params = new FormData();
      params.append("file", item.file);
      params.append("fileName", item.file.name);
      params.append("bizUid", this.detailId);
      this.uploadFile({
        params,
        config: { "Content-Type": "multipart/form-data", timeout: 100000 },
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "上传成功！",
          });
          this.handleGetFileData();
        })
        .finally(() => {
          if (this.notify) this.notify.close();
        });
    },
    handleGetFileData() {
      return this.getBusiFileData({
        bizUid: this.detailId,
        pageSize: this.fileData.pageSize,
        pageNumber: this.fileData.pageNumber,
      });
    },
    handleFileCurrentChange(val) {
      this.fileData.pageNumber = val;
      this.handleGetFileData();
    },
    handleFileSizeChange(val) {
      this.fileData.pageSize = val;
      this.fileData.pageNumber = 1;
      this.handleGetFileData();
    },
    handleDeleteFile(scope) {
      this.$confirm("是否确定删除附件？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteBusiFile({
            id: scope.row.id,
          }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.handleGetFileData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleGetProjectData() {
      return service
        .getProjectData({
          businessId: this.detailId || this.busiOpportunityDetail.id,
          pageSize: this.projectData.pageSize,
          pageNumber: this.projectData.pageNumber,
        })
        .then((res) => {
          this.projectData = res.data;
        });
    },
    handleAddProject(type) {
      if (type === "addHad") {
        this.queryVisibleProject();
      } else {
        this.handleConnectOA();
      }
    },
    // 新建项目
    async handleConnectOA() {
      const tokenData = await projectService.getOaToken();
      const businessLineIdsStr = this.busiOpportunityDetail.productLineList.reduce(
        (result, nextItem) => {
          if (result === "") {
            result += nextItem.bfmUid;
          } else {
            result += "," + nextItem.bfmUid;
          }
          return result;
        },
        ""
      );
      const oaEnv = (window.location.hostname.includes('guahao-test.com')) ? `${window.location.protocol}//192.168.99.106:8088/spa/workflow/static4form/index.html` : `${window.location.protocol}//procurement.guahao.com/spa/workflow/static4form/index.html`
      const oaPath = (window.location.hostname.includes('guahao-test.com')) ? `?ssoToken=${tokenData.data.data}&_rdm=1644891818776#/main/workflow/req?iscreate=1&workflowid=54` : `?ssoToken=${tokenData.data.data}#/main/workflow/req?workflowid=108&iscreate=1`
      if (window.location.hostname.includes('guahao-test.com')) {
        this.OAUrl = oaEnv + oaPath +
          `&field11232=${businessLineIdsStr}&field11262=${businessLineIdsStr}&field8940=${this.busiOpportunityDetail.id}`;
      } else {
        this.OAUrl = oaEnv + oaPath +
          `&field11232=${businessLineIdsStr}&field11262=${businessLineIdsStr}&field13028=${this.busiOpportunityDetail.id}`;
      }
      window.open(this.OAUrl);

      let loadingInstance = Loading.service({
        fullscreen: true,
        text: "正在打开新页面，请稍后……",
      });
      setTimeout(() => {
        this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
      }, 2000);

      // this.connectOAVisible = true;
    },
    // 已有项目查询
    // eslint-disable-next-line
    queryVisibleProject: _.debounce(function () {
      this.addProjectForm.loading = true;
      projectService
        .queryVisibleProject({
          name: this.addProjectForm.projectCode || "",
          userCode: this.busiOpportunityDetail.userId,
          businessId: this.busiOpportunityDetail.id,
        })
        .then((res) => {
          this.addProjectForm.loading = false;
          this.visibleProjectList = res.data.data;
          this.isDialogProjectVisible = true;
        });
    }, 400),
    handleAddProjectChange() {
      const { gmtCreated, ...otherParam } = this.addProjectForm.projectItem;
      service
        .addProjectData({
          businessId: this.detailId || this.busiOpportunityDetail.id,
          gmtCreatedStr: gmtCreated,
          ...otherParam,
        })
        .then((res) => {
          this.$message.success("新增已有项目成功！");
          this.isDialogProjectVisible = false;
          this.cancelProjectDialogVisible();
        });
    },
    handleDeleteProject(scope) {
      this.$confirm("是否确认把该项目从商机中移除?", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          service
            .deleteProject({
              id: scope.row.id,
            })
            .then(() => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.handleGetProjectData();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleProjectCurrentChange(val) {
      this.projectData.pageNumber = val;
      this.handleGetProjectData();
    },
    handleProjectSizeChange(val) {
      this.projectData.pageSize = val;
      this.projectData.pageNumber = 1;
      this.handleGetProjectData();
    },
    cancelProjectDialogVisible() {
      this.addProjectForm = {
        projectId: "",
        loading: false,
        projectItem: {},
      };
      this.$refs.addProjectForm.resetFields();
      this.isDialogProjectVisible = false;
      this.projectData.pageNumber = 1;
      this.handleGetProjectData();
    },
    cancelAddProjectDialogVisible() {
      this.connectOAVisible = false;
    },
    chooseProject(val) {
      this.addProjectForm.projectItem = this.visibleProjectList.find((item) => {
        return item.projectId === val;
      });
    },
    // 拜访
    toVisit() {
      this.visitDetail = {
        visitObject: 2,
        visitObjectId: this.busiOpportunityDetail.id,
        businessName: this.busiOpportunityDetail.name,
        businessId: this.busiOpportunityDetail.id,
        salesmanCode: this.userInfo.userUid,
        cluesVisible: false,
        customVisible: false,
        contactVisible: true,
        buisVisible: false,
        canEdit: false,
      };
      this.isAddVisitVisible = true;
    },
    // 获取部门列表
    async getContactDepaList() {
      const contactDepaList = [];
      if (!this.detailContacts.results) {
        await this.handleGetSalesmanData();
      }
      this.detailContacts.results.forEach((item) => {
        contactDepaList.push(item.contactDepa);
      });
      return contactDepaList;
    },
    // 产品线新增
    async handlerProductLineAdd() {
      const contactDepaList = await this.getContactDepaList();
      this.productLinetDetail = {
        id: this.busiOpportunityDetail.id,
        type: "add",
        customerId: this.busiOpportunityDetail.customerId,
        contactDepaList: contactDepaList,
        salesmanCode: this.busiOpportunityDetail.userId,
      };
      this.isProductLineDialogVisible = true;
    },

    handleProductLineCurrentChange(val) {
      this.productLineData.pageNumber = val;
      this.handleGetProductLineData();
    },
    handleProductLineSizeChange(val) {
      this.productLineData.pageSize = val;
      this.productLineData.pageNumber = 1;
      this.handleGetProductLineData();
    },
    // 产品线查询
    handleGetProductLineData(page) {
      if (page) this.productLineData.pageNumber = page?.pageNumber;
      return service
        .apiGetProductLineLine({
          pageNumber: page?.pageNumber || this.productLineData.pageNumber,
          pageSize: this.productLineData.pageSize,
          businessUid: this.businessId || this.detailId || this.busiOpportunityDetail.id,
        })
        .then((res) => {
          this.productLineData = res.data;
        });
    },
    // 产品线编辑
    async handleProductLineUpdate(scope) {
      const contactDepaList = await this.getContactDepaList();
      this.productLinetDetail = {
        id: this.busiOpportunityDetail.id,
        customerId: this.busiOpportunityDetail.customerId,
        dealAmount: scope.row.dealAmount,
        businessLineId: scope.row.id,
        name: scope.row.name,
        salesmanCode: this.busiOpportunityDetail.userId,
        type: "edit",
        contactDepaList: contactDepaList,
      };
      console.log(this.productLinetDetail, "this.productLinetDetail");
      this.isProductLineDialogVisible = true;
    },
    // 产品线删除
    handleDeleteProductLine(scope) {
      if (this.productLineData.results.length === 1) {
        this.$message.error("请至少保留一个产品线！");
        return;
      }
      this.$confirm(
        scope.row.status === "1"
          ? "该产品线已被停用，删除后将无法再次添加，是否继续？"
          : "当前操作将从商机删除该产品线，是否继续？",
        "",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          service
            .deleteProductLine({
              id: scope.row.id,
            })
            .then(() => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.handleGetProductLineData({ pageNumber: 1 });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    refreshProductLine() {
      this.isProductLineDialogVisible = false;
      this.handleGetProductLineData({ pageNumber: 1 });
    },
    // 跳转合同详情
    handleCompactDetailShow(scope) {
      if (!this.contractAuth?.contractDetailTab?.toggleStatus)
        return this.$message.error("暂无合同权限！");
      if (this.envCrm){
        this.row = scope.row;
        this.contractId = scope.row.id;
        this.compactDetailVisibleInside = true;
        setTimeout(() => {
          this.detailTabName = null
        }, 10)
      }else {
        this.row = scope.row;
        this.compactDetailId = scope.row.id;
        this.contractNumber = scope.row.contractNo;
        this.contractAmount = scope.row.contractAmount;
        this.compactDetailVisible = true;
        this.detailTabName = null;
      }
    },
    handleCloseCompactDetail() {
      this.compactDetailVisible = false;
      this.compactDetailVisibleInside = false;
    },
    // 合同列表查询
    handleGetContractData(page) {
      if (page) this.bizContractData.pageNumber = page?.pageNumber;
      const { results, ...otherParams } = this.bizContractData;
      return service
        .queryContractList({
          pageSize: this.bizContractData.pageSize,
          pageNumber: page?.pageNumber || this.bizContractData.pageNumber,
          businessId: this.busiOpportunityDetail.id,
        })
        .then((res) => {
          this.bizContractData = res.data;
        });
    },
    handleContractCurrentChange(val) {
      this.bizContractData.pageNumber = val;
      this.handleGetContractData();
    },
    handleContractSizeChange(val) {
      this.bizContractData.pageSize = val;
      this.bizContractData.pageNumber = 1;
      this.handleGetContractData();
    },
    // 新建合同
    handleAddContract(type) {
      if (type === "addHad") {
        this.$refs.chooseContract && this.$refs.chooseContract.open()
      } else {
        this.toAddContract()
      }
    },
    // 区分内部、外部（内部打开OA，外部维持原样）
    async toAddContract() {
      const envCrm = cookie.get("_env_crm__") !== "false";
      if (envCrm) {
        let loadingInstance = Loading.service({
          fullscreen: true,
          text: "正在打开新页面，请稍后……",
        });
        const tokenData = await projectService.getOaTokenInside();
        const flag = window.location.hostname.includes('crm.guahao-test.com')
        const oaEnv = flag ? `${window.location.protocol}//192.168.99.106:8088/spa/workflow/static4form/index.html` : `${window.location.protocol}//procurement.guahao.com/spa/workflow/static4form/index.html`
        const oaUrl = flag ? `#/main/workflow/req?iscreate=1&workflowid=49&_key=vc6ucz` : `#/main/workflow/req?iscreate=1&workflowid=173&_key=wkgn4i`
        const jumpUrl = flag ? `${oaEnv}?ssoToken=${tokenData.data.data}${oaUrl}`+`&field7134=${0}&field7148=11`+`&field7243=${this.busiOpportunityDetail.id}`+`&field8550=${this.busiOpportunityDetail.name}`+`&field7242=${this.busiOpportunityDetail.customerId}`+`&field7229=${this.busiOpportunityDetail.customerName}`+`&field8400=${this.busiOpportunityDetail.userId}` : `${oaEnv}?ssoToken=${tokenData.data.data}${oaUrl}`+`&field11608=${0}&field11622=11`+`&field7243=${this.busiOpportunityDetail.id}`+`&field8550=${this.busiOpportunityDetail.name}`+`&field7242=${this.busiOpportunityDetail.customerId}`+`&field7229=${this.busiOpportunityDetail.customerName}`+`&field8400=${this.busiOpportunityDetail.userId}`
        window.open(jumpUrl);
        setTimeout(() => {
          this.$nextTick(() => {
            loadingInstance.close();
          });
        }, 2000);
      } else {
        this.addCompactDialogVisible = true;
        this.compactDetail = {
          customName: this.busiOpportunityDetail.customerName,
          customId: this.busiOpportunityDetail.customerId,
          salesmanCode: this.busiOpportunityDetail?.userId || this.userInfo.userUid,
          name: this.busiOpportunityDetail.name,
          id: this.busiOpportunityDetail.id,
          productLineList: this.busiOpportunityDetail.productLineList,
          form: "busi",
        };
      }
    },
    handlerToggleChecked() {
      this.confirmForm.toggleChecked = !this.confirmForm.toggleChecked;
      if (this.confirmForm.toggleChecked) {
        this.confirmForm.end = this.confirmForm.stageTipList.length;
      } else {
        this.confirmForm.end = 3;
      }
    },
    // 关联已有合同后，刷新列表
    chooseSuccess(){
      let p = null;
      this.loading = true;
      this.bizContractData.pageNumber = 1;
      this.bizContractData.pageSize = 5;
      p = this.handleGetContractData();
      p.finally(() => {
        this.loading = false;
      });
    },
  },
  mounted() {
    this.getAuthority({ menuUrl: "/visit" });
    this.getAuthority({ menuUrl: "/compact/contract" });
    this.getAuthority({ menuUrl: "/business/opportunity" });
  },
};
</script>

<style lang="less">
@import "~@/styles/const.less";

.busi-detail-content {
  .button-stage-change {
    background-color: #2f4b84;
    color: #ffffff;
  }
  .busi-opportunity-stage {
    .el-step {
      cursor: pointer;
      .el-step__title {
        font-size: 14px;
        line-height: 20px;
        font-weight: 500;
        .el-dropdown {
          color: #fff;
          font-size: 14px;
          line-height: 20px;
          font-weight: 500;
        }
      }
      .el-step__title.is-wait {
        color: #fff;
      }
    }
    .el-step__head.is-finish {
      color: #fff;
      border-color: @busi-stage--active;
      .el-step__icon {
        background: @busi-stage--active;
      }
    }
    .el-step__title.is-finish {
      color: @busi-stage--active;
      border-color: @busi-stage--active;
    }
    .el-step__head.is-process {
      color: #fff;
      border-color: @color--active;
      .el-step__icon {
        background: @color--active;
      }
    }
    .el-step__title.is-process {
      color: @color--active;
      border-color: @color--active;
    }
    .el-step__head.is-wait {
      color: @nav-item-hover;
      border-color: @nav-item-hover;
    }
    .busi-stage-desc {
      color: #fff;
      font-size: 12px;
      line-height: 15px;
      text-align: left;
      margin: 0px 2px;
    }
  }
  ::-webkit-scrollbar-track-piece {
    display: none;
  }
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0);
  }
  :hover::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
  }
  #crumbs {
    ul {
      padding: 0;
      list-style: none;
      display: inline-table;
      li {
        margin-top: 10px;
        display: inline;
        float: left;
        a {
          display: block;
          height: 24px;
          background: #ffffff;
          text-align: center;
          padding: 0 31px;
          position: relative;
          margin: 0 5px 0 0;
          font-size: 12px;
          line-height: 24px;
          text-decoration: none;
          color: #505ea9;
        }
        a:after {
          content: "";
          border-top: 12px solid transparent;
          border-bottom: 12px solid transparent;
          border-left: 12px solid #fff;
          position: absolute;
          right: -12px;
          top: 0;
          z-index: 1;
        }
        a:before {
          content: "";
          border-top: 12px solid transparent;
          border-bottom: 12px solid transparent;
          border-left: 12px solid #4360ff;
          position: absolute;
          left: 0;
          top: 0;
        }
        span {
          display: block;
          text-align: center;
          width: 100px;
          font-size: 10px;
          line-height: 14px;
          color: #ffffff;
          margin-top: 4px;
        }
        .HoverBackground {
          background: #f0b762;
          color: #fff;
        }
        .HoverBackground:after {
          border-left: 12px solid #f0b762;
        }
        .activeBackground {
          background: #6981ff;
          color: #fff;
        }
        .activeBackground:after {
          border-left: 12px solid #6981ff;
        }
      }
      li:first-child a {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-left: 31px;
        padding-right: 31px;
      }
      li:first-child a:before {
        display: none;
      }
      li:last-child a {
        padding-right: 31px;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }
      li:last-child a:after {
        display: none;
      }
    }
  }
}
.busi-dialog {
  padding: 0 30px;
  .el-form-item__label {
    float: none;
  }
}
.dialog-title {
  text-align: center;
  margin-bottom: 20px;
  font-size: 18px;
}

.btn-toggle {
  width: 100%;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #3f86ff;
}
.project-tipText {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #7a84b7;
}
.tip {
  li {
    margin: 5px 0;
    .title-tip {
      color: #7a84b7 !important;
    }
    p {
      line-height: 14px;
      font-size: 12px !important;
      font-weight: 500;
    }
  }
}
.addProject-tip {
  margin-left: 61px;
  font-size: 12px;
  font-weight: 600;
  color: #7a84b7;
}
.addProject {
  width: 300px !important;
  .el-select > .el-input {
    width: 300px !important;
  }
  .el-input__inner {
    width: 300px !important;
  }
}
</style>
